import { LandingPage } from "../../../components/landing-page";
import { serviceLandingPages } from "../../../lib/landing-pages";

type Props = {
  slug: string;
};

export default function ServiceLandingPage({ slug }: Props) {
  const page = serviceLandingPages.find((item) => item.slug === slug);

  if (!page) return null;

  return (
    <LandingPage
      page={page}
      relatedPages={serviceLandingPages.filter((item) => item.slug !== slug)}
    />
  );
}
